// Renders a section media overlay: none | black | red | black_ltr (left-to-right blend)
export const Overlay = ({ overlay }) => {
  if (!overlay || overlay.type === "none" || !overlay.type) return null;
  const op = Math.max(0, Math.min(100, overlay.opacity ?? 0)) / 100;
  let style = {};
  if (overlay.type === "black") {
    style = { backgroundColor: `rgba(0,0,0,${op})` };
  } else if (overlay.type === "red") {
    // brand red hsl(354 79% 51%) -> approx rgb(225, 29, 56)
    style = { backgroundColor: `rgba(225,29,56,${op})` };
  } else if (overlay.type === "black_ltr") {
    style = { backgroundImage: `linear-gradient(to right, rgba(0,0,0,${op}) 0%, rgba(0,0,0,0) 100%)` };
  }
  return <div className="pointer-events-none absolute inset-0 z-[1]" style={style} aria-hidden="true" />;
};
